module.exports = __webpack_public_path__ + "static/media/DataProtection(GDPR).02355df3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/src/DataProtection(GDPR).pdf
// module id = 116
// module chunks = 0